import Vue from 'vue'
import { MutationTree } from 'vuex/types/index'

import { InquiryState } from './inquiries.types'

const mutations: MutationTree<InquiryState> = {
  SET_INQUIRIES (state, { data }) {
    if (data && data.length <= 0) {
      return
    }

    data.forEach((resource: { id: string | number }) =>
      Vue.set(state.data, resource.id, resource))
  }
}

export default mutations
